// components/js/UploadComponent.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const UploadComponent = () => {
  const [uploads, setUploads] = useState([]);

  useEffect(() => {
    axios.get('/api/uploads/')
      .then(res => setUploads(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Dataset Uploads</h2>
      <table className="w-full table-auto border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2">Name</th>
            <th className="p-2">Description</th>
            <th className="p-2">Uploaded By</th>
          </tr>
        </thead>
        <tbody>
          {uploads.map(upload => (
            <tr key={upload.upload_id} className="border-t">
              <td className="p-2">{upload.dataset_name}</td>
              <td className="p-2">{upload.description}</td>
              <td className="p-2">{upload.uploaded_by}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UploadComponent;

